import { render, staticRenderFns } from "./areaCounts.vue?vue&type=template&id=11129fd6&scoped=true&"
import script from "./areaCounts.vue?vue&type=script&lang=js&"
export * from "./areaCounts.vue?vue&type=script&lang=js&"
import style0 from "./areaCounts.vue?vue&type=style&index=0&id=11129fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11129fd6",
  null
  
)

export default component.exports